import { render, staticRenderFns } from "./CallAnalysisAdmin.vue?vue&type=template&id=c56f4ed4"
import script from "./CallAnalysisAdmin.vue?vue&type=script&lang=js"
export * from "./CallAnalysisAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports